import React from "react";
import { InView } from 'react-intersection-observer';
import scrollTo from 'gatsby-plugin-smoothscroll';
import HeaderAnim from "../utils/animations/textRevealAnimation";
import BannerSlideIn from "../utils/animations/bannerSlideIn";
import LazyLoad from 'react-lazyload';

export default function MainBanner(props) {
  const { title, header, content, mediaType, mediaSource, mediaClass, classes } = props.data;

  return (
    <InView onChange={inView => { inView ? props.setShowVerticleNav(false) : props.setShowVerticleNav(true); }}>
      <div className={`page-main-banner-section page-main-banner-liquid-image section-gap d-flex align-v-center ${classes}`}>
        <div className="container">
          <div className="row d-flex flex-wrap align-v-center justify-space">
            <div className="col page-main-banner-detail d-flex align-v-center">
              <div className="page-main-banner-detail-inner">
                {/*<h1 className="theme-color-title">{title}</h1>*/}
                <h1 className="h1">{header}</h1>
                <p>{content}</p>
                <div className="get_started_button" onClick={() => scrollTo('#form-section')}><a className='button button-white right-arrow  black-arrow' href="/contact/">Get started</a></div>
              </div>
            </div>
            <BannerSlideIn classes="col page-main-banner-image d-flex align-v-center">
              <LazyLoad>
                <img src={mediaSource} title="Digital Product Development" alt="digital product development services" />
              </LazyLoad>
            </BannerSlideIn>
          </div>
        </div>
      </div>
    </InView>
  );
}
